<script>
import pluralize from '@/helpers/pluralize'

export default ({ props, data }) => (
  <p
    class="sms-cooldown-text-component"
    { ...data }
  >
    Отправить код повторно можно через
    <br/>
    <em class="sms-cooldown-text-component__number-text">{pluralize(props.value, ['секунду', 'секунды', 'секунд'])}</em>
  </p>
);
</script>

<style lang="less">
.sms-cooldown-text-component {
  @apply text-sm font-light;
  &__number-text {
    @apply text-primary;
    font-style: normal;
  }
}
</style>
